import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import {Button} from "@mui/material";
import * as React from "react";

export default function StaffVouchersShowVoucherNumber({row, data, setData, redeem, setRow}) {

    const [actioned, setActioned] = useState(false);

    useEffect(() => {
        setActioned((row.actioned_at !== null))
    }, [])

    function markActioned(e) {
        const id = row.voucher_id;
        FunctionsData.postData(
            FunctionsData.getApiUrl('/api/voucher/update/') + id,
            {actioned_at: new Date()}
        ).then((r) => {
            console.log(r);
            setRow({...row, actioned_at: new Date()});

            let d = data;
            for (let x in d) {
                if (d[x]['voucher_id'] === id) {
                    d[x]['actioned_at'] = new Date();
                }
            }

            setData(d);
            setActioned(true);
        })
    }

    if(!redeem) return (
        <>
            {row.voucher_nr}
        </>
    )

    try {
        return (
            <>
                {row.voucher_nr}
                <div style={{fontSize:'0.8em'}}>
                    {(row.a_microchip_number.length !== 15) ? <span style={{color:'lightgray'}}>No microchip number</span> : null}
                    {(row.api_status === 'success') ? <span style={{color:'green'}}>NZCAR synced</span> : null}
                    {(row.api_status === 'error') ? <span style={{color:'red'}}>NZCAR failed</span> : null}
                    {(row.a_microchip_number.length === 15 && row.microchip_added > 0 && row.api_status === null) ? 'NZCAR API pending' : null}
                </div>
                <div>
                    {
                        (redeem) ?
                            <Button sx={{fontSize: '0.7em', opacity: 0.5, background: (actioned) ? 'green' : 'red'}}
                                    size={"small"}
                                    disabled={actioned}
                                    variant={"contained"}
                                    onClick={markActioned}
                            >
                                {
                                    (actioned !== true) ? "Mark as actioned" :(row.api_status === 'error') ? "Fix in NZCAR tab" : "Actioned"
                                }
                            </Button>
                            : undefined
                    }
                </div>
            </>
        )
    }catch(e) {
        return (
            <>
                {row.voucher_nr}
            </>
        )
    }
}
